import React, { useRef, useState } from 'react';

import useTranslation from '../../Hooks/UseTranslation';

import './DragAndDropArea.scss';

interface DragDropUploadProps {
  onFileSelected: (file: File) => void;
}

const DragAndDropArea: React.FC<DragDropUploadProps> = ({ onFileSelected }) => {

  const { t } = useTranslation()

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === 'dragenter' || e.type === 'dragover');
  };

  const handleSelectedFile = (file?: File) => {
    if (file) {
      onFileSelected(file);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    handleSelectedFile(e.dataTransfer.files?.[0]);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleSelectedFile(e.target.files?.[0]);
    e.target.value = '';
  };

  const handleBrowseFiles = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      className={`text-center drag-drop-area ${dragActive ? 'active' : ''}`}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <input
        data-testid="drag-drop-file-input"
        type="file"
        accept=".xlsx"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="drag-drop-file-input-hidden"
      />
      <p className="mb-3">
        📂 {t('TASK_IMPORTER:DragAndDrop')}
      </p>
      <div>
        <button
          type="button"
          onClick={handleBrowseFiles}
          className="btn btn-normal-2"
          style={{ cursor: 'pointer', margin: 0 }}
        >
          {t('TASK_IMPORTER:BrowseFiles')}
        </button>
      </div>
    </div>
  );
};

export default DragAndDropArea;
